import { render } from "./PhotoClassifyLineLittleView.vue?vue&type=template&id=0923a1d4&scoped=true"
import script from "./PhotoClassifyLineLittleView.vue?vue&type=script&lang=js"
export * from "./PhotoClassifyLineLittleView.vue?vue&type=script&lang=js"

import "./PhotoClassifyLineLittleView.vue?vue&type=style&index=0&id=0923a1d4&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0923a1d4"]])

export default __exports__